export default "__VITE_ASSET__ChyUoFAn__"